
import React from "react";
import { FormLabel, FormElement, FormInput } from "../../../components/StyledElements";
import { useCourseContext } from "../../../contexts/CoursesContext";


export const CoreDetails = ({ style = {}, onSelectTab = () => { } }) => {
  const { updatedCourse, setUpdatedCourse } = useCourseContext();

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>

      <FormElement style={{ flexDirection: "column", display: "flex" }}>
        {
          updatedCourse?.document_count ? (
            <FormLabel label={`${updatedCourse.document_count} Items`} />
          ) : null}
        {
          updatedCourse?.collection_chunk_count ? (
            <FormLabel label={`${updatedCourse.collection_chunk_count} Chunked Items`} />
          ) : null}
      </FormElement>

      <FormElement>
        <FormLabel label="Public ID" />
        <FormInput disabled type="text" value={updatedCourse?.public_id ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Title" />
        <FormInput type="text" placeholder="Enter course title" value={updatedCourse?.title ?? ""}
          onChange={(e) => {
            setUpdatedCourse({ ...updatedCourse, title: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Short Title" />
        <FormInput type="text" placeholder="Enter course short title" value={updatedCourse?.short_title ?? ""}
          onChange={(e) => {
            setUpdatedCourse({ ...updatedCourse, short_title: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Description" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter description"
          style={{ resize: "vertical" }}
          value={updatedCourse?.description ?? ""}
          onChange={(e) => {
            updatedCourse.description = e.target.value;
            setUpdatedCourse({ ...updatedCourse });
          }}
        />
      </FormElement>
    </div>
  );
};

export default CoreDetails;
